
export const getVisaTypeLabel = (visaType: string): string => {
  switch (visaType) {
    case 'visa_free':
      return 'Visa Free';
    case 'visa_on_arrival':
      return 'Visa on Arrival';
    case 'e_visa':
      return 'E-Visa';
    case 'visa_required':
      return 'Visa Required';
    default:
      return 'Unknown';
  }
};

export const getVisaTypeColor = (visaType: string): string => {
  switch (visaType) {
    case 'visa_free':
      return 'text-green-600 bg-green-100';
    case 'visa_on_arrival':
      return 'text-blue-600 bg-blue-100';
    case 'e_visa':
      return 'text-purple-600 bg-purple-100';
    case 'visa_required':
      return 'text-orange-600 bg-orange-100';
    default:
      return 'text-gray-600 bg-gray-100';
  }
};
